<script>
  import { getPreviewMeta } from './preview-meta.js';

  export let messages = [];
  export let compact = false;

  $: primary = messages[0] || null;
  $: count = messages.length;
  $: meta = primary ? getPreviewMeta(primary, { fallbackText: 'Chưa có nội dung.' }) : null;
</script>

<section class:compact class="preview-card">
  <div class="eyebrow">Nội dung sẽ gửi</div>

  {#if primary && meta}
    <div class="headline">
      <strong>{count > 1 ? `${count} mục đã chọn` : '1 mục đã chọn'}</strong>
      <span>{meta.label}</span>
    </div>

    <div class={`type-chip ${meta.color}`}>
      <svelte:component this={meta.icon} size={15} />
      <div class="chip-copy">
        <span>{meta.badge}</span>
        <p>{meta.text}</p>
      </div>
    </div>

    {#if count > 1}
      <div class="extra-note">Những mục còn lại sẽ được gửi kèm theo cùng lời nhắn hiện tại.</div>
    {/if}
  {:else}
    <strong>Chưa có tin nhắn được chọn</strong>
    <p>Giữ hoặc chọn tin nhắn trong cuộc trò chuyện để bật chia sẻ.</p>
  {/if}
</section>

<style>
  .preview-card {
    padding: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.24);
    border-radius: 1.3rem;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.68), rgba(248, 250, 252, 0.62));
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.45),
      0 16px 36px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(24px);
  }

  .eyebrow {
    color: #0284c7;
    font-size: 0.67rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .headline {
    margin-top: 0.45rem;
  }

  strong {
    display: block;
    color: #0f172a;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .headline span {
    display: block;
    margin-top: 0.2rem;
    color: #64748b;
    font-size: 0.76rem;
  }

  .type-chip {
    display: flex;
    align-items: flex-start;
    gap: 0.72rem;
    margin-top: 0.85rem;
    padding: 0.92rem 0.95rem;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 1.05rem;
    background: rgba(255, 255, 255, 0.42);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.32);
    backdrop-filter: blur(22px);
  }

  .type-chip.sky { color: #0369a1; background: rgba(224, 242, 254, 0.52); }
  .type-chip.rose { color: #be123c; background: rgba(255, 228, 230, 0.5); }
  .type-chip.amber { color: #c2410c; background: rgba(255, 237, 213, 0.56); }
  .type-chip.emerald { color: #047857; background: rgba(209, 250, 229, 0.52); }
  .type-chip.cyan { color: #0f766e; background: rgba(204, 251, 241, 0.54); }
  .type-chip.violet { color: #6d28d9; background: rgba(237, 233, 254, 0.54); }
  .type-chip.slate { color: #475569; background: rgba(241, 245, 249, 0.62); }

  .chip-copy {
    min-width: 0;
  }

  .chip-copy span {
    display: inline-block;
    padding: 0.14rem 0.45rem;
    border: 1px solid rgba(255, 255, 255, 0.24);
    border-radius: 999px;
    color: #0f172a;
    background: rgba(255, 255, 255, 0.64);
    font-size: 0.62rem;
    font-weight: 700;
  }

  .chip-copy p {
    margin-top: 0.45rem;
    color: inherit;
    font-size: 0.78rem;
    line-height: 1.5;
    word-break: break-word;
  }

  .extra-note {
    margin-top: 0.75rem;
    color: #64748b;
    font-size: 0.74rem;
    line-height: 1.5;
  }

  .preview-card.compact {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.25rem;
    padding: 0.62rem 0.75rem;
    border-color: #edf2f7;
    border-radius: 0.28rem;
    background: #f8fafc;
    box-shadow: none;
    backdrop-filter: none;
  }

  .preview-card.compact .eyebrow {
    display: none;
  }

  .preview-card.compact .headline {
    margin-top: 0;
  }

  .preview-card.compact strong {
    font-size: 0.82rem;
  }

  .preview-card.compact .headline span {
    display: none;
  }

  .preview-card.compact .type-chip {
    margin-top: 0.28rem;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
  }

  .preview-card.compact .chip-copy {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    min-width: 0;
  }

  .preview-card.compact .chip-copy p {
    margin-top: 0;
    overflow: hidden;
    color: #475569;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.78rem;
  }

  .preview-card.compact .extra-note {
    display: none;
  }
</style>
